<!--
 * @Author: cn1994
 * @Date: 2024-09-24 13:27:40
 * @LastEditors: cn1994
 * @LastEditTime: 2024-12-09 16:32:07
 * @Description: 输入框组件
-->
<template>
  <el-input
    v-model="inputValue"
    :type="type"
    :size="size"
    :placeholder="placeholder"
    :clearable="clearable"
    :rows="rows"
    :resize="resize"
    :maxlength="maxlength"
    :show-word-limit="showWordLimit"
    :disabled="disabled"
    :autosize="autosize"
    @clear="clear"
    @change="change"
    @blur="blur"
    :suffix-icon="suffixIcon"
  >
    <template v-for="(_, name) in $slots" v-slot:[name]="scope">
      <slot :name="name" v-bind="scope"></slot>
    </template>
  </el-input>
</template>

<script>

import mixin from './index.js'

export default {
  name: 'LsInput',
  componentName: 'LsInput',
  mixins: [mixin],
  props: {
    value: {
      type: [String, Number],
      default: '',
    },
    size: {
      type: String,
      default: 'small',
      validator: (val) => ['mini', 'small', 'medium', 'large'].includes(val),
    },
    placeholder: {
      type: String,
      default: '',
    },
    clearable: {
      type: Boolean,
      default: false
    },
    maxlength: {
      type: [Number,String],
      default: ''
    },
    showWordLimit: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    rows: {
      type: [Number,String],
      default: "2"
    },
    type: {
      type: String,
      default: 'text'
    },
    resize: {
      type: String,
      default: '',
      validator: (val) => ['none', 'both', 'horizontal', 'vertical', ''].includes(val),
    },
    autosize: {
      type: [Object, Boolean],
      default: false
    },
    suffixIcon:{
      type: String,
      default: ''
    }
  },
  data () {
    return {
    }
  },
  computed: {
    inputValue: {
      get() {
        return this.value
      },
      set(v) {
        this.$emit("input", v)
      }
    }
  },
  methods: {
    clear() {
      this.$emit('clear');
    },
    change(value) {
      this.$emit('change', value);
    },
    blur(){
      this.$emit('blur')
    }
  }
}

</script>

<style lang="less" scoped>
@import url('./index.less');
</style>